import React from 'react';
import { Hero } from "../../components/hero/Hero";
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {Solutions} from "../../components/solutions/Solutions";
import {BasicAnimation} from "../../components/animations/BasicAnimation";
import {Helmet} from "react-helmet";

export class ProductCategories extends React.Component {

  render() {
    return (
      <div>
        
        <Helmet>
          <title>Products | Obelux Aviation Lights</title>
          <meta name="description" content="OBELUX Led Aviation Obstruction Lights for Airports, Wind, Telecom and other large structures."></meta>
          <meta name="og:description" content="OBELUX Led Aviation Obstruction Lights for Airports, Wind, Telecom and other large structures."></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <header>
          <Hero title="Products"
                subtitle="OBELUX Led Aviation Obstruction Lights for Airports, Wind, Telecom and other large structures."
                image={require('../../assets/images/obelux-www-intro_contr.jpg')}
                align="center"
                className="medium-hero"
          />
        </header>
        <BasicAnimation duration={800} delay={0}>
          <Solutions/>
        </BasicAnimation>
        <ContactUsHiddenFormSection/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/views/products/ProductCategories.js